// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{display:inline-block;position:relative;line-height:0}:host canvas,:host img{width:100%;height:100%}:host img{display:inline-block;position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
